// External places the gallery links to (change a URL here and every link follows)
export const FLIPBOOK_URL = "/flipbook";
// opens The Flipbook inside the gallery (full-screen overlay); `from` = where it was opened
export const openFlipbook = (from = "link") => window.dispatchEvent(new CustomEvent("afae-flipbook", { detail: from }));
